import React from 'react';
import CardButton from '../CardButton/CardButton';
import './HomeSlide.css';
import ProgressMeter from '../ProgressMeter/ProgressMeterTutor';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_overview} from '../../../../../cosmosTracking/cosmosEvents';
import Lottie from "react-lottie";
import homeSlideAnimation from '../../../Resources/Slides/indipendence/home.json';

function HomeSlide(props) {
	const { data, campaignOrg, rewardText } = props;

	const homeSlideAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: homeSlideAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	return (
		<div className="slideCard slideCardHome">
			<div className="cardHeader">
				<Lottie options={homeSlideAnimationLottie} height={174}></Lottie>
			</div>
			<div className="cardContent">
				<div className="revenueData">
					<div>
						<h4>{data?.revenueCard?.text}</h4>
						<h1>{data?.revenueCard?.total}</h1>
					</div>
					<p>Goal: {data?.revenueCard?.goal}</p>
				</div>
				<div className="meterData">
					<ProgressMeter width={data?.revenueCard?.percentage}/>
				</div>
				<div className="pointDataGroup">
					<div className="pointData">
						<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-medal-star.png" width={22} height={22} alt="medal-star"/>
						<h3>{data?.rankCard?.title + data?.rankCard?.subText}<span>{(data?.rankCard?.text)?.toLowerCase()}</span></h3>
					</div>
					<div className="pointData">
						<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-point-icon.png" alt="circle-point" width={22}/>
						<h3>{data?.pointsCard?.title}<span>{(data?.pointsCard?.text)?.toLowerCase()}</span></h3>
					</div>
				</div>
				<CardButton text={'See now'}
							deeplink={data?.deeplinkOverview}
							className={'btn-action'}
							eventCallback={() => {cosmosTrackService(view_overview)}}>
				</CardButton>
			</div>
		</div>
	);
}

export default HomeSlide;
